import { DistributionCenter } from '@api/DistributionCenters/DistributionCenter';
import DistributionCenterServ from '@api/DistributionCenters/DistributionCenterServ';
import { BranchOffice } from '@api/BranchOffices/BranchOffice';

class DistributionCenterService {
    saveDistributionCenter = (distributionCenter: DistributionCenter): Promise<DistributionCenter> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await DistributionCenterServ.saveDistributionCenter(distributionCenter);
                resolve(data);
            } catch (error) {
                reject('Error saving distribution center: ' + error);
            }
        });
    };
    getDistributionCenters = (): Promise<DistributionCenter[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await DistributionCenterServ.getDistributionCenters();
                resolve(data);
            } catch (error) {
                reject('Error getting distribution centers: ' + error);
            }
        });
    };
    getDistributionCenter = (distributionCenterId: string): Promise<DistributionCenter> => {
        return new Promise(async (resolve, reject) => {
            try {
                const distributionCenter = await DistributionCenterServ.getDistributionCenter(distributionCenterId);
                resolve(distributionCenter);
            } catch (error) {
                reject('Error getting distribution center: ' + error);
            }
        });
    };

    getDistributionCenterByManagerId = (managerId: string): Promise<DistributionCenter | undefined> => {
        return new Promise(async (resolve, reject) => {
            try {
                const distributionCenter = await DistributionCenterServ.getDistributionCenterByManagerId(managerId);
                resolve(distributionCenter);
            } catch (error) {
                reject('Error getting distribution center: ' + error);
            }
        });
    };

    deleteDistributionCenter = (distributionCenterId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await DistributionCenterServ.deleteDistributionCenter(distributionCenterId);
                resolve();
            } catch (error) {
                reject('Error deleting distribution center: ' + error);
            }
        });
    };
    toggleStatus = (distributionCenterId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await DistributionCenterServ.toggleStatus(distributionCenterId);
                resolve();
            } catch (error) {
                reject('Error updating branch office status: ' + error);
            }
        });
    };
    getBranchOffices = (distributionCenterId: string): Promise<BranchOffice[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const branchOffices = await DistributionCenterServ.getBranchOffices(distributionCenterId);
                resolve(branchOffices);
            } catch (error) {
                reject('Error getting branch offices: ' + error);
            }
        });
    };
}
export default DistributionCenterService;
